import Repository from '../../../Repository';
import { computed } from 'vue';
import store from '@/store';
import { useToast } from 'vue-toastification';

const company = computed(() => store.getters['company/info']);
const toast = useToast();

export default {
	index(params) {
		return Repository.get(`/company/${company.value.id}/admin/sale`, { params: params });
	},
	assignIndex(params) {
		return Repository.get(`/company/${company.value.id}/admin/sale/assign`, { params: params });
	},
	assign(id) {
		return Repository.put(`/company/${company.value.id}/admin/sale/assign/${id}`).then((response) => {
			toast.success(`Venta asignada correctamente.`);
			return response;
		});
	},
	unassign(id) {
		return Repository.delete(`/company/${company.value.id}/admin/sale/assign/${id}`).then((response) => {
			toast.success(`Venta desasignada correctamente.`);
			return response;
		});
	}
}